<div class="container-cx-login">
  <ng-container *ngIf="user$ | async as user; else login">
    <div class="cx-login-greet">
      {{ 'miniLogin.userGreeting' | cxTranslate: { name: user.name } }}
    </div>

    <div class="container-floating-menu">
      <div class="my-account-label">
        {{ 'navMenu.myAccount' | cxTranslate }}
        <span class="material-symbols-outlined"> keyboard_arrow_down </span>
      </div>

      <cx-my-account></cx-my-account>
    </div>
  </ng-container>

  <ng-template #login>
    <div class="container-mini-login">
      <div class="container-register-login">
        <a
          role="link"
          [routerLink]="{ cxRoute: 'login' } | cxUrl"
          [title]="'miniLogin.signInRegister' | cxTranslate"
          (click)="closeMainMenu()"
        >
          <span class="icon material-symbols-outlined d-flex m-r-4"> person </span>
          <span class="label">{{ 'miniLogin.signInRegister' | cxTranslate }}</span>
        </a>
        |
        <a role="link" href="/login/register" [title]="'miniLogin.register' | cxTranslate" (click)="closeMainMenu()">
          <span class="label">
            {{ 'miniLogin.register' | cxTranslate }}
          </span>
        </a>
      </div>

      <div class="mini-login">
        <p class="title">
          {{ 'miniLogin.signInRegister' | cxTranslate }}
        </p>

        <a
          class="btn btn-primary btn-sm"
          role="link"
          [routerLink]="{ cxRoute: 'login' } | cxUrl"
          [title]="'miniLogin.signIn' | cxTranslate"
        >
          <span>
            {{ 'miniLogin.signIn' | cxTranslate }}
          </span>

          <span class="material-symbols-outlined"> login </span>
        </a>

        <a
          class="btn btn-primary btn-sm"
          role="link"
          [routerLink]="{ cxRoute: 'register' } | cxUrl"
          [title]="'miniLogin.register' | cxTranslate"
        >
          <span>
            {{ 'miniLogin.register' | cxTranslate }}
          </span>

          <span class="icon material-symbols-outlined"> how_to_reg </span>
        </a>
      </div>
    </div>
  </ng-template>
</div>
